import React, { ReactElement, lazy } from "react";
import { useRouteLoaderData } from "react-router-dom";

import { AuthContext } from "./AuthContext";
import { AuthObj, AuthProviderProps } from "./AuthContext.types";

import { RootLoaderData } from "@utils/Types";

const LazyErrorPage = lazy(() => import("../../workflows/support/ErrorPage"));

export const AuthProvider = ({ children }: AuthProviderProps): ReactElement | null => {
  const { authorization } = useRouteLoaderData("root") as RootLoaderData;

  if (!authorization) {
    console.error("No authorization data found");
    return <LazyErrorPage type={500} />;
  }

  const authObj: AuthObj = {};

  authorization.forEach((auth) => {
    authObj[auth.subcategory] = {
      hasWriteAccess: auth.authority === "WRITE",
      visible: auth.authority === "READ" || auth.authority === "WRITE",
    };
  });

  return <AuthContext.Provider value={{ authorization: authObj }}>{children}</AuthContext.Provider>;
};
